import { createAPI } from "services/api/api";
import { getUrlByPathname } from "consts/APIUrls";
import { useEffect } from "react";
import useFiltersQueryParams from "./useFiltersQueryParams";
import { useDispatch, useSelector } from "react-redux";
import { setactiveItem, setTotalCount } from "store/cards";
import useProfile from "./useProfile";
import { useLocation } from "react-router-dom";

const usePageItems = (
  setItems,
  setPaginationData,
  offsetCount,
  setIsItemsLoading,
  order
) => {
  const {pathname} = useLocation();
  const { searchParams } = useFiltersQueryParams();
  const dispatch = useDispatch();
  const { refreshTrigger } = useSelector((state) => state.cards);
  const {token, flags} = useProfile();
  const {view_expired_event} = flags;
  const searchInputValue = searchParams.get("search");

  const getParamsForExpiredEvents = () => {
    if (pathname.includes('events') && view_expired_event === true) {
      return '&show_expired=true'
    } else return ''
  };

  useEffect(() => {
    const api = createAPI();
    const controller = new AbortController();
    const signal = controller.signal;

    const params =
      searchParams.size > 0
        ? decodeURIComponent(searchParams.toString()) + "&"
        : "";
    const currentOrder = order ? `&order=${order}` : "";

    const searchQuery = searchInputValue ? `&search=${searchInputValue}` : "";

    const fetchData = async () => {
      if (
        !pathname.includes("card-pack-open") &&
        (!pathname.includes("/dashboard") || pathname.includes("buypacks"))
      ) {
        setIsItemsLoading(true);
        dispatch(setactiveItem(null));
        try {
          const { data } = await api.get(
            `${
              getUrlByPathname(pathname).items
            }params?${params}limit=20&offset=${offsetCount}${currentOrder}${searchQuery}${getParamsForExpiredEvents()}`,
            { signal }
          );

          setItems(data.data !== null ?  data.data : []);
          setPaginationData(data.pagination_metadata);
          dispatch(setTotalCount(data.pagination_metadata.total_count));
        } catch (error) {
          console.error("usePageItemsError", error);
          setItems([]);
        } finally {
          setIsItemsLoading(false);
        }
      }
    };

    if (token) {
      fetchData();
    }

    return () => {
      controller.abort();
      dispatch(setTotalCount(0));
      setItems([]);
      setPaginationData({});
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, pathname, offsetCount, order, searchParams, refreshTrigger]);
};

export default usePageItems;
